<template>
  <div class="mobile-nav">
    <!-- 汉堡菜单按钮 -->
    <div
      class="hamburger-btn"
      @click="toggleMenu"
      :class="{ active: isMenuOpen }"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>

    <!-- 移动端菜单遮罩 -->
    <div
      class="mobile-menu-overlay"
      :class="{ active: isMenuOpen }"
      @click="closeMenu"
    ></div>

    <!-- 移动端侧边栏菜单 -->
    <div class="mobile-menu-sidebar" :class="{ active: isMenuOpen }">
      <div class="mobile-menu-header">
        <div class="mobile-logo" @click="goHome">
          <img src="@/assets/images/logo.png" alt="logo" class="logo-img" />
          <span class="brand-name">{{ $t("nav.brand") }}</span>
        </div>
        <div class="close-btn" @click="closeMenu">
          <i class="el-icon-close"></i>
        </div>
      </div>

      <nav class="mobile-menu-content">
        <ul class="mobile-menu-list">
          <li
            v-for="item in navList"
            :key="item.path"
            @click="handleNavClick(item.path)"
          >
            <router-link :to="item.path" active-class="active-link" exact>
              {{ item.label }}
            </router-link>
          </li>
        </ul>
      </nav>

      <div class="mobile-menu-footer">
        <el-button
          class="contact-btn"
          type="default"
          size="medium"
          @click="handleContact"
        >
          {{ $t("nav.contact") }}
        </el-button>
        <div class="lang-switch" @click="toggleLanguage">
          <span class="flag-circle-outer">
            <img
              :src="
                currentLanguage === 'zh'
                  ? require('@/assets/images/english.png')
                  : require('@/assets/images/chinese.png')
              "
              :alt="currentLanguage === 'zh' ? 'English' : '中文'"
              class="flag-img"
            />
          </span>
          <span class="lang-text">{{
            currentLanguage === "zh" ? "English" : "中文"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileNav",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    navList() {
      return [
        { label: this.$t("nav.home"), path: "/" },
        { label: this.$t("nav.services"), path: "/services" },
        { label: this.$t("nav.story"), path: "/about" },
        { label: this.$t("nav.testimonials"), path: "/testimonials" },
        { label: this.$t("nav.parents"), path: "/parents" },
        { label: this.$t("nav.blog"), path: "/blog" },
      ];
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      // 防止body滚动
      if (this.isMenuOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = "";
    },
    handleNavClick(path) {
      this.closeMenu();
      this.$router.push(path);
    },
    goHome() {
      this.closeMenu();
      this.$router.push("/");
    },
    handleContact() {
      this.closeMenu();
      // 这里可以添加联系逻辑
    },
    toggleLanguage() {
      const newLang = this.currentLanguage === "zh" ? "en" : "zh";
      this.$i18n.locale = newLang;
      localStorage.setItem("language", newLang);
    },
  },
  beforeDestroy() {
    // 组件销毁时恢复body滚动
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
// .mobile-nav {
//   display: none;

//   @media (max-width: $breakpoint-sm) {
//     display: block;
//   }
// }

.hamburger-btn {
  width: 24px;
  height: 24px;
  position: relative;
  cursor: pointer;
  z-index: 1001;

  span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #282938;
    position: absolute;
    left: 0;
    transition: all 0.3s ease;

    &:nth-child(1) {
      top: 4px;
    }

    &:nth-child(2) {
      top: 11px;
    }

    &:nth-child(3) {
      top: 18px;
    }
  }

  &.active {
    span {
      &:nth-child(1) {
        transform: rotate(45deg);
        top: 11px;
      }

      &:nth-child(2) {
        opacity: 0;
      }

      &:nth-child(3) {
        transform: rotate(-45deg);
        top: 11px;
      }
    }
  }
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;

  &.active {
    opacity: 1;
    visibility: visible;
  }
}

.mobile-menu-sidebar {
  position: fixed;
  top: 0;
  right: -280px;
  width: 280px;
  height: 100%;
  background-color: #fff;
  z-index: 1000;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;

  &.active {
    right: 0;
  }
}

.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;

  .mobile-logo {
    display: flex;
    align-items: center;
    cursor: pointer;

    .logo-img {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      margin-right: 10px;
      object-fit: contain;
    }

    .brand-name {
      font-size: 16px;
      font-weight: 600;
      color: #282938;
    }
  }

  .close-btn {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;

    &:hover {
      color: #282938;
    }
  }
}

.mobile-menu-content {
  flex: 1;
  padding: 20px 0;

  .mobile-menu-list {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      border-bottom: 1px solid #f5f5f5;

      a {
        display: block;
        padding: 16px 20px;
        color: #282938;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.2s ease;

        &.active-link {
          color: $primary-color;
          background-color: #f8f9fa;
        }

        &:hover {
          color: $primary-color;
          background-color: #f8f9fa;
        }
      }
    }
  }
}

.mobile-menu-footer {
  padding: 20px;
  border-top: 1px solid #f0f0f0;

  .contact-btn {
    width: 100%;
    margin-bottom: 16px;
    border: 1.5px solid #282938;
    border-radius: 22px;
    background: #fff;
    color: #282938;
    font-weight: 500;
    height: 44px;
    transition: all 0.2s;

    &:hover {
      background: #282938;
      color: #fff;
    }
  }

  .lang-switch {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 12px;
    border-radius: 8px;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f8f9fa;
    }

    .flag-circle-outer {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
      margin-right: 8px;
    }

    .flag-img {
      width: 30px;
      height: 30px;
      object-fit: cover;
      border-radius: 50%;
    }

    .lang-text {
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }
  }
}
</style>
